// extracted by mini-css-extract-plugin
module.exports =  {"phone":"_93444fe79c--phone--Fv2IK"};